import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import { useReplies } from '../../_load/ServiceOrderLoader'
import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Separator from '../../../../../components/pdf/Separator'

const Summaries = ({ hardwareData, softwareData, servicesData }) => {
  const replies = useReplies()

  const programLength = getReplyValue(findReplyByQuestionId(replies, 337))
  const totalCost = getReplyValue(findReplyByQuestionId(replies, 338))
  const estimatedTotalWTax = getReplyValue(findReplyByQuestionId(replies, 339))
  const averageSavingsPerYear = getReplyValue(findReplyByQuestionId(replies, 340))
  const totalSavings = getReplyValue(findReplyByQuestionId(replies, 341))

  return (
    <Grid direction="row" gutter={20} align="flex-start">
      <Col flex={1} gutter={20}>
        <Text bold size="h5">
          Quote Summary
        </Text>
        <Separator weight={5} />
        <Table width="100%" fixedLayout useFontBaseColor>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor style={{ backgroundColor: '#e7e6e6' }}>
              <Text>Program Length</Text>
            </TableCol>
            <TableCol useFontBaseColor>
              <Text>{programLength}</Text>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor>
              <Text bold>TOTAL COST</Text>
            </TableCol>
            <TableCol useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
              <Text>{totalCost}</Text>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor>
              <Text bold>ESTIMATED TOTAL W/ TAX</Text>
            </TableCol>
            <TableCol useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
              <Text>{estimatedTotalWTax}</Text>
            </TableCol>
          </TableRow>
        </Table>
      </Col>
      <Col flex={1} gutter={20}>
        <Text bold size="h5">
          Discount Summary
        </Text>
        <Separator weight={5} />
        <Table width="100%" fixedLayout useFontBaseColor>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor style={{ backgroundColor: '#e7e6e6' }}>
              <Text>Average Savings Per Year</Text>
            </TableCol>
            <TableCol useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
              <Text>{averageSavingsPerYear}</Text>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor>
            <TableCol useFontBaseColor>
              <Text bold>TOTAL SAVINGS</Text>
            </TableCol>
            <TableCol useFontBaseColor style={{ backgroundColor: '#ffe599' }}>
              <Text>{totalSavings}</Text>
            </TableCol>
          </TableRow>
        </Table>
      </Col>
    </Grid>
  )
}

export default Summaries
